

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};


export const validatePassword = (password) => {
  // Password should be at least 8 characters long and include a number and a special character
  const re = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return re.test(password);
};

export const validateTempPassword = (tempPassword) => {
  const re = /^[A-Za-z0-9!@#$%^&*()_+-=]{6,12}$/;
  return re.test(tempPassword);
};


export const validateTime = (operatingHours) => {
  const re = /^([0-9]|[01]\d|2[0-3]):([0-5]\d)-([0-9]|[01]\d|2[0-3]):([0-5]\d)$/;
  return re.test(operatingHours)

};

export const validateMobileNumber = (mobileNumber) => {
  const re = /^[0-9]{10}$/; // Exactly 10 digits
  return re.test(mobileNumber);
};

export const validateVerifyCode = (mobileNumber) => {
  const re = /^[0-9]{6}$/; // Exactly 10 digits
  return re.test(mobileNumber);
};

export const validateText = (text) => {
  const re = /^[A-Za-z]+$/; // Only alphabets
  return re.test(text);
};

export const validateNumber = (number) => {
  const re = /^[0-9]+$/; // Only digits
  return re.test(number);
};


export const getCurrentFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const validateEmailOrMobile = (email) => {
  if (!email) {
    return 'Please enter a valid email or mobile number';
  }

  const isNumber = /^[0-9]+$/.test(email); // Checks if the input is entirely numeric
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); // Checks for a valid email format

  if (isNumber) {
    if (email.length !== 10) {
      return 'Please enter a valid 10-digit mobile number';
    }
  } else if (!isEmail) {
    return 'Please enter a valid email';
  }

  return null; // No error
};


// converting GMT to Local (Use This for All Formart);

export const convertGMTToLocal = (gmtDateString, format) => {
  if (!gmtDateString) { return '--' }
  const gmtDate = new Date(gmtDateString + " GMT"); // Ensuring it's treated as GMT
  const padZero = (num) => String(num).padStart(2, '0');
  // console.log("gmtDateString",gmtDateString)

  const year = gmtDate.getFullYear();
  const month = padZero(gmtDate.getMonth() + 1); // Months are 0-based
  const day = padZero(gmtDate.getDate());
  const hours = padZero(gmtDate.getHours());
  const minutes = padZero(gmtDate.getMinutes());
  const seconds = padZero(gmtDate.getSeconds());
  const formats = {
    "dd MMM yyyy": gmtDate.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).replace(',', ''),
    "dd-MM-yyyy": gmtDate.toLocaleDateString('en-GB').split('/').join('-'),
    "dd/MM/yyyy": gmtDate.toLocaleDateString('en-GB'),
    "dd/MM/yyyy, hh:mm A": gmtDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '').replace(/\s(am|pm)/i, (match) => ` ${match.toUpperCase()}`),
    "EEEE MMM dd, hh:mm A": gmtDate.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }),
    "yyyy-MM-dd'T'HH:mm": `${year}-${month}-${day}T${hours}:${minutes}`, // Correct local time
    "yyyy-MM-dd": `${year}-${month}-${day}`, // Correct local time use this for Date Input 
    "yyyy-MM-dd HH:mm:ss": `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` // Correct local time use this for Date Time Input 
  };

  return formats[format] || formats["dd-MM-yyyy"]; // Default to first format if invalid
};

export const formatDateTimeWithSeconds = (dateTimeStr) => {
  // Check if dateTime already has seconds
  return dateTimeStr.includes(":") && dateTimeStr.split(":").length === 3
    ? dateTimeStr.replace("T", " ")  // Already has seconds, just replace 'T' with space
    : dateTimeStr.replace("T", " ") + ":00"; // Append ':00' if seconds are missing
};

// Utility to convert date range to day names and dates
export const getLeaveDatesWithDays = (startDateStr, endDateStr) => {
  const result = [];

  if (!startDateStr || !endDateStr) return result;

  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Convert to IST
  const IST_OFFSET = 5.5 * 60 * 60 * 1000;
  const startIST = new Date(startDate.getTime() + IST_OFFSET);
  const endIST = new Date(endDate.getTime() + IST_OFFSET);

  // Start from the next day ONLY if the start time is not midnight
  let current = new Date(startIST.getFullYear(), startIST.getMonth(), startIST.getDate());
  if (
    startIST.getHours() !== 0 ||
    startIST.getMinutes() !== 0 ||
    startIST.getSeconds() !== 0
  ) {
    current.setDate(current.getDate() + 1);
  }

  // End at the same day IF time is before midnight, otherwise we include that day
  const end = new Date(endIST.getFullYear(), endIST.getMonth(), endIST.getDate());
  if (
    endIST.getHours() === 0 &&
    endIST.getMinutes() === 0 &&
    endIST.getSeconds() === 0
  ) {
    end.setDate(end.getDate() - 1);
  }

  while (current <= end) {
    const date = current.toLocaleDateString("en-GB"); // dd/MM/yyyy
    const day = current.toLocaleDateString("en-US", { weekday: "long" });
    result.push({ date, day });

    current.setDate(current.getDate() + 1);
  }

  return result;
};
// export const getLeaveDatesWithDays = (startDateStr, endDateStr) => {
//   const result = [];
//   // const start = new Date(startDateStr);
//   // const end = new Date(endDateStr);
//   if (!startDateStr || !endDateStr) return result;
//   console.log('startDateStr endDateStr :',startDateStr, endDateStr)

//   // Convert the GMT string to Date objects
//   const startGMT = new Date(startDateStr + " GMT");
//   const endGMT = new Date(endDateStr + " GMT");

//   // const startDate = startGMT.toLocaleDateString('en-GB')
//   // console.log('startDate : ',startDate)
//   // const endDate = endGMT.toLocaleDateString('en-GB')
//   // console.log('endDate : ',endDate)

//   // const start = new Date(startDateStr);
//   // const end = new Date(endDateStr);

//   // Shift to IST (UTC+5:30 = 19800000 ms)
//   const IST_OFFSET = 5.5 * 60 * 60 * 1000;
//   const startIST = new Date(startGMT.getTime() + IST_OFFSET);
//   const endIST = new Date(endGMT.getTime() + IST_OFFSET);

//   // Extract and normalize start and end dates (strip time)
//   const startY = startIST.getFullYear();
//   const startM = String(startIST.getMonth() + 1).padStart(2, '0');
//   const startD = String(startIST.getDate()).padStart(2, '0');

//   const endY = endIST.getFullYear();
//   const endM = String(endIST.getMonth() + 1).padStart(2, '0');
//   const endD = String(endIST.getDate()).padStart(2, '0');

//   let current = new Date(`${startY}-${startM}-${startD}`);
//   const end = new Date(`${endY}-${endM}-${endD}`);

//   while (current <= end) {
//     const date = current.toLocaleDateString("en-GB"); // dd/MM/yyyy
//     const day = current.toLocaleDateString("en-US", { weekday: "long" });
//     result.push({ date, day });

//     current.setDate(current.getDate() + 1);
//   }

//   console.log('result', result)

//   return result;
// };
export const getLeaveWeekdays = (startDateStr, endDateStr) => {
  const days = [];
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);

  while (start <= end) {
    const day = start.toLocaleDateString("en-US", { weekday: "long" });
    days.push(day);
    start.setDate(start.getDate() + 1);
  }

  return days;
};

// Utility to convert date range to dates
export const getLeaveDates = (startDateStr, endDateStr) => {
  const dates = [];
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);

  while (start <= end) {
    const formatted = start.toLocaleDateString("en-GB"); // dd/MM/yyyy
    dates.push(formatted);
    start.setDate(start.getDate() + 1);
  }

  return dates;
};

export const getLocalDateTime = () => {
  const pad = (n) => String(n).padStart(2, '0');
  const date = new Date();

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};


